import { memo } from 'react'
import { CheckboxBox } from '@/components/forms/ui/checkbox-box'

type CheckboxProps = {
  htmlfor: string
  register: any
  required?: any
}

/** 個人情報の取り扱いへの同意チェック。エラー時は親に .error_input を付けると枠が赤くなる */
export const Checkbox = memo(
  ({ htmlfor, register, required }: CheckboxProps) => {
    return (
      <label
        htmlFor={htmlfor}
        className="flex cursor-pointer items-start gap-3 text-left"
      >
        <CheckboxBox>
          <input
            type="checkbox"
            value=""
            id={htmlfor}
            className="peer sr-only"
            {...register(htmlfor, {
              required
            })}
          />
        </CheckboxBox>
        <span className="text-sm leading-compact text-ink">
          <a
            href="/privacy-policy/"
            target="_blank"
            className="text-ink-link hover:underline"
            rel="noopener"
          >
            個人情報の取り扱い
          </a>
          に同意し送信します
        </span>
      </label>
    )
  }
)
Checkbox.displayName = 'Checkbox'
